import {GitHubApiConnection, GitHubApiKey} from '@package/shared'
import type {z} from 'zod'

export const FormValues = GitHubApiConnection.pick({
  name: true,
}).extend({
  apiKey: GitHubApiKey,
})
export type FormValues = z.infer<typeof FormValues>
